module.exports = __webpack_public_path__ + "media/directory/social_icon-6ed8b1f6.svg";